import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import InputColor from '../../layout/input/InputColor';

class Mobile extends AbstractComponent {            
    render() {
        return(                                                                 
            <Fragment>   
                <InputColor
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="color_header_mobile"
                    nome="color_header_mobile"                    
                    value={this.props.form.color_header_mobile}
                    defaultValue={this.props.form.color_header_mobile}
                    erro={this.props.erroForm.color_header_mobile}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Header
                </InputColor> 
                
                <InputColor
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="background_footer_mobile"
                    nome="background_footer_mobile"                    
                    value={this.props.form.background_footer_mobile}
                    defaultValue={this.props.form.background_footer_mobile}
                    erro={this.props.erroForm.background_footer_mobile}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Footer
                </InputColor> 

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="color_icon_footer_mobile"
                    nome="color_icon_footer_mobile"                    
                    value={this.props.form.color_icon_footer_mobile}
                    defaultValue={this.props.form.color_icon_footer_mobile}
                    erro={this.props.erroForm.color_icon_footer_mobile}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Icon Footer
                </InputColor> 

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="color_icon_footer_mobile_active"
                    nome="color_icon_footer_mobile_active"                    
                    value={this.props.form.color_icon_footer_mobile_active}
                    defaultValue={this.props.form.color_icon_footer_mobile_active}
                    erro={this.props.erroForm.color_icon_footer_mobile_active}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Icon Footer Active
                </InputColor>                

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="background_badge_mobile"
                    nome="background_badge_mobile"                    
                    value={this.props.form.background_badge_mobile}
                    defaultValue={this.props.form.background_badge_mobile}
                    erro={this.props.erroForm.background_badge_mobile}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Badge
                </InputColor> 

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="color_badge_mobile"
                    nome="color_badge_mobile"                    
                    value={this.props.form.color_badge_mobile}
                    defaultValue={this.props.form.color_badge_mobile}
                    erro={this.props.erroForm.color_badge_mobile}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Badge
                </InputColor>                 

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="background_cart_mobile"
                    nome="background_cart_mobile"                    
                    value={this.props.form.background_cart_mobile}
                    defaultValue={this.props.form.background_cart_mobile}
                    erro={this.props.erroForm.background_cart_mobile}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Carrinho
                </InputColor>

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="color_cart_mobile"
                    nome="color_cart_mobile"                    
                    value={this.props.form.color_cart_mobile}
                    defaultValue={this.props.form.color_cart_mobile}
                    erro={this.props.erroForm.color_cart_mobile}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Carrinho
                </InputColor>

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="background_bagde_cart_mobile"
                    nome="background_bagde_cart_mobile"                    
                    value={this.props.form.background_bagde_cart_mobile}
                    defaultValue={this.props.form.background_bagde_cart_mobile}
                    erro={this.props.erroForm.background_bagde_cart_mobile}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Badge Carrinho
                </InputColor>

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="color_bagde_cart_mobile"
                    nome="color_bagde_cart_mobile"                    
                    value={this.props.form.color_bagde_cart_mobile}
                    defaultValue={this.props.form.color_bagde_cart_mobile}
                    erro={this.props.erroForm.color_bagde_cart_mobile}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Badge Carrinho
                </InputColor>                                  
            </Fragment>
        )
    }
}

export default Mobile;